"use client"

import { useState, useRef, useEffect } from "react"
import { Link } from "react-router-dom"
import { Calendar, Clock, MapPin, Play, Pause, Radio, X, FileText, Download } from "lucide-react"
import { VizagHero } from "./VizagHero"
// import { CalendarButton } from "./CalendarButton"

export function HeroSection({ currentEdition = "bangalore", onPresentationsClick, onAgendaClick }) {
  return currentEdition === "vizag-2026" ? <VizagHero onPresentationsClick={onPresentationsClick} onAgendaClick={onAgendaClick} /> : <HistoricalHeroSection currentEdition={currentEdition} />
}

function HistoricalHeroSection({ currentEdition }) {
  const [isVideoPlaying, setIsVideoPlaying] = useState(true)
  const [showNotification, setShowNotification] = useState(false)
  const [showAgenda, setShowAgenda] = useState(false) // State for PDF modal
  const [showRegistrationForm, setShowRegistrationForm] = useState(false) // State for Registration Form modal
  const [isFormLoading, setIsFormLoading] = useState(true) // State for form loading
  const videoRef = useRef(null)

  const isVizagEdition = currentEdition === "vizag"
  const isChennaiEdition = currentEdition === "chennai"
  const editionDetails = {
    vizag: {
      year: "2025",
      label: "Vizag Edition",
      date: "August 22, 2025 (Friday)",
      time: "9:30 AM - 5:00 PM IST",
      location: "Visakhapatnam",
    },
    bangalore: {
      year: "2025",
      label: "Bengaluru Edition",
      date: "November 7, 2025 (Friday)",
      time: "9:00 AM - 5:00 PM IST",
      location: "Bengaluru",
    },
    chennai: {
      year: "2026",
      label: "Chennai Edition",
      date: "July 3, 2026 (Friday)",
      time: "9:00 AM - 6:00 PM IST",
      location: "Vivanta, Chennai",
    },
  }
  const edition = editionDetails[currentEdition] || editionDetails.bangalore

  // Watch Live Links - ADD YOUR LINKS HERE
  // const WATCH_LIVE_LINKS = {
  //   vizag: "https://youtu.be/2112-BiWqrA?si=oiLLLY3tn4966KUr",
  //   bangalore: "https://www.youtube.com/live/K675u0mhX6o?feature=share"
  // }

  // Auto-close notification after 3 seconds
  useEffect(() => {
    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [showNotification])

  const toggleVideo = () => {
    if (videoRef.current) {
      if (isVideoPlaying) {
        videoRef.current.pause()
      } else {
        videoRef.current.play()
      }
      setIsVideoPlaying(!isVideoPlaying)
    }
  }

  // const handleWatchLiveClick = () => {
  //   const watchLiveLink = isVizagEdition ? WATCH_LIVE_LINKS.vizag : WATCH_LIVE_LINKS.bangalore

  //   if (watchLiveLink) {
  //     // Open watch live link in new tab
  //     window.open(watchLiveLink, "_blank")
  //   } else {
  //     // Show coming soon notification if no link is set
  //     setShowNotification(true)
  //   }
  // }

  const handleEventAgendaClick = () => {
    // Show PDF agenda modal.
    setShowAgenda(true)
  }

  // const handleRegistrationClick = () => {
  //   // Bangalore Edition: Show registration form popup
  //   setShowRegistrationForm(true)
  //   setIsFormLoading(true)
  // }

  return (
    <>
      {/* PDF Agenda Modal - For Both Editions */}
      {showAgenda && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
          <div className="bg-white/95 rounded-2xl shadow-2xl w-full max-w-4xl h-[90vh] flex flex-col overflow-hidden">
            <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/80">
              <h3 className="text-lg font-semibold text-gray-800">Event Agenda</h3>
              <div className="flex items-center gap-4">
                <a
                  href={isVizagEdition ? "/cts_agenda.pdf" : isChennaiEdition ? "/cts_chennai_agenda.pdf" : "/cts_banglore_agenda.pdf"}
                  download={isVizagEdition ? "Candela_Technology_Summit_2025_Vizag_Agenda.pdf" : isChennaiEdition ? "Candela_Technology_Summit_2026_Chennai_Agenda.pdf" : "Candela_Technology_Summit_2025_Bangalore_Agenda.pdf"}
                  className="flex items-center gap-2 text-white bg-green-600 hover:bg-green-700 transition-colors px-4 py-2 rounded-lg text-sm font-medium"
                >
                  <Download className="w-4 h-4" />
                  <span>Download PDF</span>
                </a>
                <button
                  onClick={() => setShowAgenda(false)}
                  className="text-gray-500 hover:text-gray-800 hover:bg-gray-200 p-2 rounded-full"
                  aria-label="Close agenda view"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
            </div>

            <div className="flex-grow">
              <iframe
                src={isVizagEdition ? "/cts_agenda.pdf" : isChennaiEdition ? "/cts_chennai_agenda.pdf" : "/cts_banglore_agenda.pdf"}
                title="Event Agenda PDF"
                width="100%"
                height="100%"
                className="border-none"
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* Registration Form Modal - For Bangalore Edition */}
      {currentEdition === "bangalore" && showRegistrationForm && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
          <div className="bg-white/95 rounded-2xl shadow-2xl w-full max-w-4xl h-[90vh] flex flex-col overflow-hidden">
            <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/80">
              <h3 className="text-lg font-semibold text-gray-800">Registration Form</h3>
              <button
                onClick={() => setShowRegistrationForm(false)}
                className="text-gray-500 hover:text-gray-800 hover:bg-gray-200 p-2 rounded-full"
                aria-label="Close registration form"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            <div className="flex-grow relative">
              {isFormLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-white/80">
                  <div className="flex flex-col items-center gap-4">
                    <div className="w-12 h-12 border-4 border-green-600 border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-gray-600 font-medium">Loading registration form...</p>
                  </div>
                </div>
              )}
              <iframe
                src="https://forms.gle/snMoKCSEfCKsT62j9"
                title="Registration Form"
                width="100%"
                height="100%"
                className="border-none"
                onLoad={() => setIsFormLoading(false)}
              ></iframe>
            </div>
          </div>
        </div>
      )}

      <section className="relative min-h-screen flex items-center justify-center overflow-hidden text-center">
        {/* Video Background */}
        <div className="absolute inset-0 z-0">
          <video ref={videoRef} autoPlay muted loop playsInline className="w-full h-full object-cover">
            <source src={isVizagEdition ? "/wifi-fest_new.mp4" : isChennaiEdition ? "/wifi-fest_chennai.mp4" : "/wifi-fest_banglore.mp4"} type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-black/30 to-black/40"></div>
        </div>

        {/* Coming Soon Notification - For Bangalore Edition */}
        {!isVizagEdition && showNotification && (
          <div className="fixed top-24 left-1/2 -translate-x-1/2 z-[9999] w-11/12 max-w-md bg-green-600/90 backdrop-blur-md text-white p-4 rounded-xl shadow-2xl border border-white/20 animate-fade-in-down">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <Radio className="w-6 h-6 text-green-200" />
              </div>
              <div className="ml-3 flex-1">
                <p className="text-base font-semibold">Coming Soon</p>
                {/* <p className="text-sm mt-1">
                  This feature will be available soon. Stay tuned!
                </p> */}
              </div>
              <button
                onClick={() => setShowNotification(false)}
                className="ml-4 p-1 rounded-md hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white"
                aria-label="Close notification"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        )}

        {/* Video Control Button */}
        <button
          onClick={toggleVideo}
          className="absolute top-6 right-6 z-30 w-12 h-12 bg-white/80 backdrop-blur-md rounded-full flex items-center justify-center text-green-700 hover:bg-white/90 transition-all duration-300 shadow-lg"
          aria-label={isVideoPlaying ? "Pause video" : "Play video"}
        >
          {isVideoPlaying ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5" />}
        </button>

        {/* Centered Content Container */}
        <div className="relative z-20 flex flex-col items-center w-full max-w-4xl px-4">
          
          <div className="mb-1 animate-fade-in-up z-10">
            <img src={isChennaiEdition ? "/images/chennai/CTS_3D copy.png" : "/images/cts_logo.png"} alt="Summit Logo" className={isChennaiEdition ? "w-72 md:w-96 h-auto object-contain drop-shadow-xl" : "w-48 h-48 md:w-56 md:h-56 object-contain drop-shadow-xl"} />
          </div>

          <div className="bg-white/10 backdrop-blur-md border-2 border-white/30 rounded-2xl p-8 md:p-12 shadow-2xl hover:bg-white/15 hover:border-white/40 transition-all duration-500 hover:scale-[1.02] w-full mb-8 overflow-hidden">
            <div className="pt-4">
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg animate-fade-in-up animation-delay-200">
                Candela Technology
                <span className="block" style={{ color: '#eab308' }}>Summit {edition.year}</span>
              </h1>
              {!isChennaiEdition && (
                <div className="flex flex-row items-center justify-center gap-4 flex-wrap">
                  <span className="inline-flex items-center gap-2 backdrop-blur-sm px-4 py-2 rounded-full font-semibold shadow-lg border border-white/30 text-white text-base shrink-0" style={{ backgroundColor: '#eab308' }}>
                    <MapPin className="w-5 h-5 text-red-500" />
                    {edition.label}
                  </span>
                </div>
              )}
              {isChennaiEdition && (
                <div className="-mx-8 md:-mx-12 -mb-8 md:-mb-12 mt-8 bg-white px-6 py-6 rounded-b-2xl">
                  <div className="flex flex-col items-center gap-5 sm:flex-row sm:items-center sm:justify-center sm:gap-12">
                    <div className="flex flex-col items-center gap-2">
                      <p className="text-[11px] sm:text-xs text-gray-500 font-medium tracking-[0.2em] uppercase text-center">
                        In Technical Partnership With
                      </p>
                      <div className="w-16 h-px bg-gray-200"></div>
                      <img
                        src="/images/WKS white logo.png"
                        alt="WiFi Knowledge Summit"
                        className="h-9 sm:h-10 md:h-11 object-contain object-center mt-1 brightness-0"
                      />
                    </div>
                    <div className="hidden sm:block w-px self-stretch bg-gray-200"></div>
                    <div className="flex w-full flex-col items-center gap-2 sm:w-auto">
                      <p className="text-[11px] sm:text-xs text-gray-500 font-medium tracking-[0.2em] uppercase text-center">
                        Summit Partners
                      </p>
                      <div className="w-16 h-px bg-gray-200"></div>
                      <div className="mt-1 flex w-full items-center justify-center gap-3 sm:w-auto sm:gap-5">
                        <img
                          src="/badge/chennailabs.png"
                          alt="Chennai Labs"
                          className="max-h-5 w-auto max-w-[44%] object-contain object-center sm:h-6 sm:max-h-none sm:max-w-none"
                        />
                        <div className="h-7 w-px shrink-0 bg-gray-200"></div>
                        <img
                          src="/badge/tekiknow.png"
                          alt="Tekiknow"
                          className="max-h-9 w-auto max-w-[44%] translate-y-[3px] object-contain object-center sm:h-9 sm:max-h-none sm:max-w-none md:h-10"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* <p className="text-xl text-white/90 leading-relaxed drop-shadow-md animate-fade-in-up animation-delay-400">
                Join us for a deep dive into cutting-edge wireless technology, evolving Wi-Fi standards, and advanced testing strategies driving real-world user experience.
              </p> */}
            </div>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 animate-fade-in-up animation-delay-600">
            <div className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20">
              <Calendar className="w-5 h-5" />
              <span className="font-medium">
                {edition.date}
              </span>
            </div>
            <div className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20">
              <Clock className="w-5 h-5" />
              <span className="font-medium">
                {edition.time}
              </span>
            </div>
            {isChennaiEdition ? (
              <a
                href="https://www.google.com/maps/dir//vivanta+chennai+it+expressway+chennai/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x3a525b9ecc7572e7:0xe53a02455570c2df?sa=X&ved=1t:155782&ictx=111"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20 hover:bg-white/20 transition-colors duration-300"
              >
                <MapPin className="w-5 h-5" />
                <span className="font-medium">{edition.location}</span>
              </a>
            ) : (
              <div className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20">
                <MapPin className="w-5 h-5" />
                <span className="font-medium">
                  {edition.location}
                </span>
              </div>
            )}
            
            {/* <button
              onClick={handleWatchLiveClick}
              className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20 hover:bg-white/20 transition-colors duration-300"
            >
              <Radio className="w-5 h-5 text-green-300" />
              <span className="font-medium">Watch live</span>
            </button> */}
            
            {/* Event Agenda Button — Chennai opens the dedicated agenda page; others open the PDF modal */}
            {isChennaiEdition ? (
              <Link
                to="/agenda"
                className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20 hover:bg-white/20 transition-colors duration-300"
              >
                <FileText className="w-5 h-5" />
                <span className="font-medium">Event Agenda</span>
              </Link>
            ) : (
              <button
                onClick={handleEventAgendaClick}
                className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20 hover:bg-white/20 transition-colors duration-300"
              >
                <FileText className="w-5 h-5" />
                <span className="font-medium">Event Agenda</span>
              </button>
            )}
            
            {/* <CalendarButton
              edition={currentEdition}
              className="font-medium !h-auto !min-w-min flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20 hover:bg-white/20"
            /> */}

            {/* {!isVizagEdition && (
              <button
                onClick={handleRegistrationClick}
                className="flex items-center gap-2 text-white bg-black/30 backdrop-blur-sm px-4 py-2 rounded-lg shadow-md border border-white/20 hover:bg-white/20 transition-colors duration-300"
              >
                <FileText className="w-5 h-5" />
                <span className="font-medium">Register Now</span>
              </button>
            )} */}
          </div>
        </div>
      </section>
    </>
  )
}
